export function getAnswerFile(answer) {
  return answer?.file || null;
}

export function getQuestionTypeLabel(type) {
  if (type === 'multiple_choice') {
    return 'چهارگزینه‌ای';
  }

  if (type === 'instructional') {
    return 'دستورالعمل';
  }

  return 'تشریحی';
}

export function isQuestionAnswered(question, answer = {}) {
  if (question.type === 'instructional') {
    return Boolean(getAnswerFile(answer));
  }

  if (question.type === 'multiple_choice') {
    return Boolean(answer.selectedOptionId);
  }

  if (question.type === 'descriptive') {
    return Boolean((answer.textAnswer || '').trim());
  }

  return Boolean(answer.selectedOptionId || (answer.textAnswer || '').trim() || getAnswerFile(answer));
}
